import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  AxiosAPI,
  getGroupID,
  getUserID,
} from '../../../../../../helpers/AxiosAPI';
import {
  postAPI_Update_User,
  gAPI_Users_By_Id,
  getAPI_SSO_By_GroupId,
} from '../../../../../../constants/APIs';
import EditUsersForm from './EditUsersForm';
import Validation from '../../../../../../components/Validation';

function UpdateUsersForm({
  id,
  userName,
  serviceProvider,
  isSuperAdmin,
  ssoStatus,
}) {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [isUpdating, setIsUpdating] = useState(false);
  const [userProperty, setUserProperty] = useState([]);
  const [userRole, setUserRole] = useState([]);
  const isSSOViewMode =
    ssoStatus?.toLowerCase() === 'active' &&
    (serviceProvider === '2' || serviceProvider === '5');
  useEffect(() => {
    if (id !== undefined && isUpdating) {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
      }).then((res) => {
        var userproperties = res.data.properties;
        setUserRole(res.data.roles);
        setUserProperty(userproperties);
      });
    }
  }, [id, isUpdating]);
  const handleSubmit = (data) => {
    const formmatedData = {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      status: data.status,
      properties: data.properties,
      roles: data.roles,
      phoneNumber: data.phoneNumber,
      updater: 'admin',
      groupId: getGroupID(),
      auditby: userName,
    };
    // console.log(formmatedData);
    AxiosAPI({
      method: 'put',
      url: `${postAPI_Update_User}/${id}`,
      data: formmatedData,
    }).then((res) => {
      if (
        res.data.HttpStatusCode !== undefined &&
        res.data.HttpStatusCode === 400 &&
        res.data.Messages !== undefined &&
        res.data.Messages !== null &&
        res.data.Messages.length > 0
      ) {
        setMsg(res.data.Messages);
        setOpen(true);
      } else {
        setTimeout(() => {
          window.location.reload();
        }, 300);
      }
    });
  };

  return (
    <div>
      <Button
        color={isSSOViewMode ? 'secondary' : 'primary'}
        size="xs"
        onClick={() => setIsUpdating(!isUpdating)}
      >
        {isSSOViewMode ? 'View' : 'Edit'}
      </Button>

      {isUpdating && (
        <EditUsersForm
          formLabel={isSSOViewMode ? 'View User' : 'Edit User'}
          visible={isUpdating}
          isSuperAdmin={isSuperAdmin}
          toggle={() => setIsUpdating(!isUpdating)}
          id={id}
          submit={handleSubmit}
          userProperty={userProperty}
          userRole={userRole}
          serviceProvider={serviceProvider}
          isViewMode={isSSOViewMode}
        />
      )}
      <Validation open={open} messages={msg} toggle={() => setOpen(!open)} />
    </div>
  );
}

const mapStateToProps = ({ usersListApp, settings }) => {
  const { userName, serviceProvider } = settings;
  const { isSuperAdmin } = usersListApp;
  return { userName, serviceProvider, isSuperAdmin };
};
export default injectIntl(connect(mapStateToProps, {})(UpdateUsersForm));
// UpdateRatePlansForm.propTypes = {
//   id: PropTypes.string.isRequired,
//   applicableAddOnsWithIdAndName: PropTypes.array.isRequired,
//   includedAddOnsWithIdAndName: PropTypes.array.isRequired,
//   applicablePromosWithIdAndName: PropTypes.array.isRequired,
// };
